export const getMainSite = () => process.env.NODE_ENV === 'development' ? 
  process.env.REACT_APP_DEVELOPMENT_LETS_FORM_SITE : process.env.REACT_APP_PRODUCTION_LETS_FORM_SITE;